import React, { useEffect, useState } from "react";
import {
  Checkbox,
  Modal,
  IconButton ,
  Typography,
  Card,
  Grid,
  InputLabel,
  CardContent,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  Button,
  Tooltip,
  TextField,
  CircularProgress,
  FormControlLabel,
  Switch,
  Alert, 
  AlertTitle,
  FormControl,
  MenuItem,
} from "@mui/material";
import { Theme, useTheme } from '@mui/material/styles'
import { createStyles, makeStyles } from '@mui/styles';
import { useLocalStorage } from "../../utils/LocalStorageHook";
import { GetEquipmentMapping } from "../../utils/GetAdmin";
import {checkForRole} from "../../utils/GetAuth";
import { saveEquipmentMapping } from "../../utils/PostAdmin";
import TableAbstraction from "../../componentUtils/TableAbstraction";
import LockIcon from '@mui/icons-material/Lock';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import SaveIcon from '@mui/icons-material/Save';
import Clear from "@mui/icons-material/Clear";
import Select, { SelectChangeEvent } from '@mui/material/Select';

function getModalStyle() {
  const top = 50;
  const left = 50;

  return {
      top: `${top}%`,
      left: `${left}%`,
      transform: `translate(-${top}%, -${left}%)`,
  };
}


const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    centerDiv: {
      textAlign: "center",
    },
    root: {},
    divWidth: {
      width: "100%",
    },
    gridSpaceable: {
      padding: theme.spacing(2),
    },
    gridMarginTop: {
      marginTop: theme.spacing(2),
    },
    checkbox: {
      padding: 0,
    },
    modal: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    modalGrid: {
      marginTop: theme.spacing(2),
    },
    modalTitle:{
      color: theme.palette.primary.main,
    },
    modalCard: {
    },
    modalText: {
      paddingLeft: theme.spacing(1),
      paddingRight: theme.spacing(1),
      width: 500,
      maxWidth: 500
    },
    modalInput: {
      paddingLeft: "20px", 
      paddingRight: "20px", 
      width:"350px"
    },
    paper: {
        position: 'absolute',
        backgroundColor: theme.palette.background.paper,
        border: `1px solid`,
        borderColor: theme.palette.border.main, 
        boxShadow: theme.shadows[4],
        padding: theme.spacing(2, 2, 2),
    },
  })
);

function ReadOnlyCheckBox(isChecked:boolean){
  const classes = useStyles();
  return (
    <Checkbox
      checked={isChecked}
      name="active"
      color="primary"
      className={classes.checkbox}
    />
  )
}

export default function AdminEquipmentMapping() {
  const classes = useStyles();
  const [equipmentMapping, SetEquipmentMapping] = useState<any[]>([]);
  const [salesOrg,] = useLocalStorage("SETTINGS.salesOrg", "");
  const [doneLoading, setDoneLoading] = React.useState<boolean>();
  const [clientId,] = useLocalStorage("SETTINGS.clientId", "100");
  const enabled = checkForRole(clientId,salesOrg,'vp_admin');
  const [muiTable, setMuiTable] = React.useState<any>({rpp:25});
  const [useCompact] = useLocalStorage("SETTINGS.compact", true);
  
  const header =  document.querySelector('ResponsiveDrawer')
  const headerAdj = header?header.clientHeight:250;
  const [TABLE_BODY_HEIGHT, setTABLE_BODY_HEIGHT] = React.useState<string>(`${window.innerHeight - headerAdj }px`);
  window.addEventListener('resize', ()=>{
    setTABLE_BODY_HEIGHT(`${window.innerHeight - headerAdj }px`);
  })
  const [editedRowModel, seteditedRowModel] = React.useState<string>("");
  const [editedRowMaster, seteditedRowMaster] = React.useState<string>("");
  const [editedRowmaxFlavors, seteditedRowmaxFlavors] = React.useState<string>("");
  const [editedRowdoubleColumns, seteditedRowdoubleColumns] = React.useState<string>("");
  const [editedRowitemsPerRow, seteditedRowitemsPerRow] = React.useState<string>("");
  const [editedRowcolumnConfig, seteditedcolumnConfig] = React.useState<string>("");
  const [editedRowminFlavors, seteditedminFlavors] = React.useState<string>("");
  const [editedRowguid, seteditedRowguid] = React.useState<string>("");
  const [editedRowfirstColumn, seteditRowfirstColumn] = React.useState<string>("");
  const [editedRowglassFront, seteditRowglassFront] = React.useState('');
  const [editedRowMachineType, setEditedRowMachineType] = React.useState<string>("");

  const handleDelete = () => {
    let newmapdata = {model: editedRowModel, master:editedRowMaster, maxFlavors:editedRowmaxFlavors,doubleColumns:editedRowdoubleColumns,itemsPerRow:editedRowitemsPerRow,columnConfig:editedRowcolumnConfig,minFlavors:editedRowminFlavors,guid:editedRowguid,firstColumn:editedRowfirstColumn,glassFront:editedRowglassFront,machineModelType:editedRowMachineType};
    
    saveEquipmentMapping(salesOrg,newmapdata,undefined).then((ret:any) => {
      if(ret && ret.data){
        SetEquipmentMapping(ret.data.mdEquipmentModelMap)
        if(ret.data.message){
          alert(ret.data.message);
        }
      }
    });
    setEditedRow(undefined);
  }
  const setCurrent = (editedRow:any) => {
    //console.log(editedRow);
    setEditedRow(editedRow);
    seteditedRowModel(editedRow.model);
    seteditedRowMaster(editedRow.master);
    seteditedRowmaxFlavors(editedRow.max_flavors);
    seteditedRowdoubleColumns(editedRow.double_columns);
    seteditedRowitemsPerRow(editedRow.items_per_row);
    seteditedcolumnConfig(editedRow.column_config);
    seteditedminFlavors(editedRow.min_flavors);
    seteditedRowguid(editedRow.guid);
    seteditRowfirstColumn(editedRow.first_column);
    seteditRowglassFront(editedRow.glass_front);
    setEditedRowMachineType(editedRow.machine_model_type);
  }
  const clearCurrent = () => {
    setEditedRow(undefined);
    seteditedRowModel("");
    seteditedRowMaster("");
    seteditedRowmaxFlavors("");
    seteditedRowdoubleColumns("");
    seteditedRowitemsPerRow("");
    seteditedcolumnConfig("");
    seteditedminFlavors("");
    seteditedRowguid("");
    seteditRowfirstColumn("");
    seteditRowglassFront("");
    setEditedRowMachineType("");
  }
  const handleEdit = (editedRow:any) => {
    setCurrent(editedRow);
    setOpenEditWindow(true);
  }
  const [editedRow, setEditedRow] = React.useState<any|undefined>(undefined);
  const [modalStyle] = React.useState(getModalStyle);
  const [openDeleteWindow, setopenDeleteWindow] = React.useState(false);
  const [openEditWindow, setOpenEditWindow] = React.useState(false);
  const handleModalClose = () => {
    setOpenEditWindow(false);
    clearCurrent();
    setEditedRow(undefined);
  }
  const handleModalSave = () => {
    let oldmap = (editedRow) ? {
      model: editedRow.model,
      master:editedRow.master,
      maxFlavors:editedRow.maxFlavors,
      doubleColumns:editedRow.doubleColumns,
      itemsPerRow:editedRow.itemsPerRow,
      columnConfig:editedRow.columnConfig,
      minFlavors:editedRow.minFlavors,
      guid:editedRow.guid,
      firstColumn:editedRow.firstColumn,
      glassFront:editedRow.glassFront,
      machineModelType:editedRow.machineModelType,
    } : undefined;
    let newmap = {model: editedRowModel, master:editedRowMaster, maxFlavors:editedRowmaxFlavors,doubleColumns:editedRowdoubleColumns,itemsPerRow:editedRowitemsPerRow,columnConfig:editedRowcolumnConfig,minFlavors:editedRowminFlavors,guid:editedRowguid,firstColumn:editedRowfirstColumn,glassFront:editedRowglassFront,machineModelType:editedRowMachineType};

    saveEquipmentMapping(salesOrg,undefined,newmap).then((ret:any) => {
      if(ret && ret.data){
       SetEquipmentMapping(ret.data.mdEquipmentModelMap);
      }
    });
    setOpenEditWindow(false);
    setEditedRow(undefined);
  } 

  const handleChange = (event:SelectChangeEvent) => {
   // console.log(event.target.value);
     seteditRowglassFront(event.target.value as string);
  };

  const handleChangeOnFirstColumn = (event:SelectChangeEvent) => {
   // console.log(event.target.value);
    seteditRowfirstColumn(event.target.value as string);
  };
  
  
  const modalBody = (
    <div style={modalStyle} className={classes.paper} >
    <Typography variant="h4" className={classes.modalTitle} paragraph>Equipment Mapping</Typography>
    <Grid container spacing={2} className={classes.modalGrid}>
      <Grid item xs={12}>
        <Card className={classes.modalCard}>
          <CardContent>
          <Grid container spacing={1} className={classes.modalGrid}>
            <Grid item xs={'auto'} md={'auto'} xl={'auto'}>
            <InputLabel >Model</InputLabel>
            <TextField placeholder='Model' type='text'
                className={classes.modalInput}
                value={editedRowModel}
                onChange={(e) => { 
                  seteditedRowModel((e.target.value &&  typeof e.target.value == 'string') ? e.target.value : "") 
                }}></TextField>
            </Grid>
            <Grid item xs={'auto'} md={'auto'} xl={'auto'}>
            <InputLabel >Master</InputLabel>
            <TextField placeholder='Master' type='text'
                className={classes.modalInput}
                value={editedRowMaster}
                onChange={(e) => { 
                  seteditedRowMaster((e.target.value &&  typeof e.target.value == 'string') ? e.target.value : "") 
                }}></TextField>
            </Grid>
            <Grid item xs={'auto'} md={'auto'} xl={'auto'}>
            <InputLabel >Max Flavors</InputLabel>
            <TextField placeholder='Max Flavors' type='text'
                className={classes.modalInput}
                value={editedRowmaxFlavors}
                onChange={(e) => { 
                  seteditedRowmaxFlavors((e.target.value &&  typeof e.target.value == 'string') ? e.target.value : '') 
                }}></TextField>
            </Grid>
            <Grid item xs={'auto'} md={'auto'} xl={'auto'}>
            <InputLabel >Min Flavors</InputLabel>
            <TextField placeholder='Min Flavors' type='number'
                className={classes.modalInput}
                value={editedRowminFlavors}
                onChange={(e) => { 
                  const re = /[0-9]+/g;
                  seteditedminFlavors((re.test(e.target.value)) ? e.target.value : '') 
                }}></TextField>
            </Grid>
            <Grid item xs={'auto'} md={'auto'} xl={'auto'}>
            <InputLabel >Column Config</InputLabel>
            <TextField placeholder='Column Config' type='text'
                className={classes.modalInput}
                value={editedRowcolumnConfig}
                onChange={(e) => { 
                  seteditedcolumnConfig((e.target.value &&  typeof e.target.value == 'string') ? e.target.value : "") 
                }}></TextField>
              </Grid>
                <Grid item xs={'auto'} md={'auto'} xl={'auto'}>
                            <InputLabel >Item Per Row</InputLabel>
                            <TextField placeholder='Item Per Row' type='number'
                                className={classes.modalInput}
                                value={editedRowitemsPerRow}
                                onChange={(e) => { 
                                  const re = /[0-9]+/g;
                                  seteditedRowitemsPerRow((re.test(e.target.value)) ? e.target.value : '') 
                                }}></TextField>
              </Grid>
             <Grid item xs={'auto'} md={'auto'} xl={'auto'}>
              <FormControl variant="standard" sx={{ m: 1, minWidth: 350 }}>
                <InputLabel id="demo-simple-select-standard-label">Machine Type</InputLabel>
                <Select
                  labelId="demo-simple-select-standard-label"
                  id="demo-simple-select-standard"
                  value={editedRowMachineType}
                  onChange={(e) => setEditedRowMachineType(e.target.value)}
                  label="Machine Type"
                >
                  <MenuItem value={"MM"}>MicroMart</MenuItem> 
                  <MenuItem value={"CNG"}>Coke & Go</MenuItem>
                  <MenuItem value={"GFV"}>Glass Front Vendor</MenuItem>
                  <MenuItem value={"SV"}>Stack Vendor</MenuItem>              
                </Select>
              </FormControl>
              </Grid>
           
            {(editedRowMachineType && editedRowMachineType !== 'MM' && editedRowMachineType !== 'CNG' && editedRowMachineType !== 'GFV') &&
              (
            <Grid item xs={'auto'} md={'auto'} xl={'auto'}>
            <InputLabel >Double Columns</InputLabel>
            <Checkbox
                    name="doubleColumns"
                    color="primary"
                    value="X"
                    checked={editedRowdoubleColumns === 'X' ? true : false}
                    onChange={(e) => { 
                      seteditedRowdoubleColumns((e.target.checked) ? e.target.value : '') 
                    }}
                  />
              </Grid>
             )}
              {(editedRowMachineType === 'MM' || editedRowMachineType === 'CNG' ||  editedRowMachineType === 'GFV') && (
                <Grid item xs={'auto'} md={'auto'} xl={'auto'}>
                <FormControl variant="standard" sx={{ m: 1, minWidth: 335 }}>
                  <InputLabel id="demo-simple-select-standard-label">Row Config</InputLabel>
                  <Select
                    labelId="demo-simple-select-standard-label"
                    id="demo-simple-select-standard"
                    value={editedRowglassFront}
                    onChange={handleChange}
                    label="Row Config"
                  >
                    <MenuItem value={4}>4 row </MenuItem> 
                    <MenuItem value={5}>5 row </MenuItem>
                    <MenuItem value={6}>6 row </MenuItem>
                    <MenuItem value={7}>7 row </MenuItem>
                    <MenuItem value={8}>8 row </MenuItem>
                    <MenuItem value={9}>9 row </MenuItem>
                  
                  </Select>
                </FormControl>
                </Grid>
              )}
             {(editedRowMachineType === 'MM' || editedRowMachineType === 'CNG' ||  editedRowMachineType === 'GFV') && (
              <Grid item xs={'auto'} md={'auto'} xl={'auto'}>
                <FormControl variant="standard" sx={{ m: 1, minWidth: 335 }}>
                  <InputLabel id="demo-simple-select-standard-label">First Column</InputLabel>
                  <Select
                    labelId="demo-simple-select-standard-label"
                    id="demo-simple-select-standard"
                    value={editedRowfirstColumn}
                    onChange={handleChangeOnFirstColumn}
                    label="First Column"
                  >
                    <MenuItem value={1}>1</MenuItem> 
                    <MenuItem value={11}>11</MenuItem>
                    <MenuItem value={"A1"}>A1</MenuItem>               
                  </Select>
                </FormControl>
                </Grid>
               )}
            </Grid>
            </CardContent>
          </Card>
          <div style={{ paddingRight: "5px", textAlign:"right"}}>
                <React.Fragment>
                    <Tooltip title={"Save"}>
                        <IconButton onClick={handleModalSave}>
                            <SaveIcon />
                        </IconButton>
                    </Tooltip>
                    <Tooltip title={"Cancel"}>
                        <IconButton onClick={handleModalClose}>
                            <Clear />
                        </IconButton>
                    </Tooltip>
                </React.Fragment>
              </div>
        </Grid>
      </Grid>
    </div>
  );

  useEffect(() => {
    if (doneLoading) return;
    GetEquipmentMapping(salesOrg).then((v) => {
      setDoneLoading(true);
      if(v && v.mdEquipmentModelMap) SetEquipmentMapping(v.mdEquipmentModelMap);
    });
  }, [equipmentMapping,doneLoading,salesOrg]);
  return (
    <div className={classes.root}>
      {doneLoading && enabled ? (
        <TableAbstraction
          settingsKey="ADM_EQM"
          options={{
            draggableColumns: {
              enabled: true,
            },
            rowsPerPageOptions: [25, 50, 100],
            serverSide: false,
            selectableRows: "none",
            rowsPerPage: muiTable.rpp,
            onChangeRowsPerPage: (numberOfRows) => {
              muiTable.rpp = numberOfRows;
              setMuiTable(muiTable);
            },
            customToolbar: () => {
              return (
                <Tooltip title={`Add Mapping`}>
                  <IconButton  onClick={() => {
                    handleModalClose();
                    setOpenEditWindow(true);
                  }}>
                    <AddIcon />
                  </IconButton>
                </Tooltip>
              );
            },
          }}
          title="Equipment Mapping"
          columns={[
            {
              label: "Model",
              name: "model",
              options: {
                searchable: true,
                filter: false,
              },
            },
            {
              label: "Model",
              name: "hasActive",
              options: {
                display: false,
                searchable: true,
                filter: true,
                customBodyRender: (value: any) => {
                  return (
                    <FormControlLabel
                      label={value ? "Active" : "InActive"}
                      value={value ? "Active" : "InActive"}
                      control={
                        <Switch color="primary" checked={value} value={value ? "Active" : "InActive"} />
                      }
                      
                    />
                  );
                },
              },
            },
            {
              label: "Count",
              name: "cnt",
              options: {
                searchable: true,
                filter: false,
                customBodyRender: (value: any) => {
                  return `${value ? value : 0}`;
                },
              },
            },
            {
              label: "Master",
              name: "master",
              options: {
                searchable: true,
                filter: false,
              },
            },
            {
              label: "Double Columns",
              name: "double_columns",
              options: {
                filter: false,
                customBodyRender: (value: any) => (
                  <Checkbox
                    checked={value && value === 'X'}
                    name="doubleColumns"
                    color="primary"
                    className={classes.checkbox}
                  />
                ),
              },
            },
            {
              label: "Items Per Row",
              name: "items_per_row",
              options: {
                searchable: true,
                filter: false,
              },
            },
            {
              label: "Machine Type",
              name: "model_type",
              options: {
                searchable: true,
                filter: false,
                
              },
            },
            {
              label: "Column Config",
              name: "column_config",
              options: {
                searchable: true,
                filter: false,
              },
            },
            {
              label: "Min Flavors",
              name: "min_flavors",
              options: {
                searchable: true,
                filter: false,
              },
            },
            {
              label: "First Column",
              name: "first_column",
              options: {
                searchable: true,
                filter: false,
              },
            },
            {
              label: "Max Flavors",
              name: "max_flavors",
              options: {
                searchable: true,
                filter: false,
              },
            },
            {
              label: "guid",
              name: "guid",
              options: {
                searchable: false,
                filter: false,
                display: false,
              },
            },
            {
              label: " ",
              name: "remove",
              options: {
                filter: false,
                setCellProps: () => ({ align: 'right' }),
                renderCell: (params) => {
                  if(!!useCompact)
                    return (
                        <React.Fragment>
                          <Tooltip title={"Edit"}>
                            <EditIcon 
                              fontSize="small"  
                              onClick={() => {handleEdit(params.row)}}/>
                          </Tooltip>
                          <Tooltip title={"Delete"}>
                            <DeleteIcon
                              fontSize="small" 
                              onClick={() => {setCurrent(params.row); setopenDeleteWindow(true);}} 
                            />
                          </Tooltip>
                        </React.Fragment>
                      );
                    else
                      return (
                          <React.Fragment>
                            <Tooltip title={"Edit"}>
                              <IconButton onClick={() => {handleEdit(params.row)}}>
                                <EditIcon />
                              </IconButton>
                            </Tooltip>
                            <Tooltip title={"Delete"}>
                              <IconButton onClick={() => {setCurrent(params.row); setopenDeleteWindow(true);}}>
                                <DeleteIcon />
                              </IconButton>
                            </Tooltip>
                          </React.Fragment>
                        );
                },
              },
            },
          ]}
          data={equipmentMapping}
        />
      ) : ( enabled ? (
        <div className={classes.centerDiv}>
          <CircularProgress color="primary" />
        </div>) : (
          <Alert severity="error">
            <AlertTitle><LockIcon/> Access Error</AlertTitle>   
            You do not currently have access to <strong>Admin</strong> activities for the <strong>{salesOrg}</strong> bottler. 
          </Alert>
        )
      )}
       <Modal
                open={openEditWindow}
                onClose={handleModalClose}
            >
                {modalBody}

            </Modal>
            <Dialog
            open={openDeleteWindow}
            onClose={handleModalClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogContent>
              <DialogContentText id="alert-dialog-description">
              Are you sure you want to delete mapping for model "{editedRowModel}"?
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button onClick={()=>{handleDelete(); setopenDeleteWindow(false);}} color="primary">
                Yes
              </Button>
              <Button onClick={()=>{setEditedRow(undefined); setopenDeleteWindow(false);}} color="primary" autoFocus>
                No
              </Button>
            </DialogActions>
      </Dialog>
    </div>
  );
}